import { render, staticRenderFns } from "./EditActive2.vue?vue&type=template&id=0a2c99e0&scoped=true&"
import script from "./EditActive2.vue?vue&type=script&lang=js&"
export * from "./EditActive2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2c99e0",
  null
  
)

export default component.exports